import { importAll } from 'qunji-common-vue-pc/src/utils/operation'

importAll(require.context('qunji-common-vue-pc/src/icons/svg', false, /\.svg$/))
